'use strict';

exports.__esModule = true;
var VERSION = '1.5.2';

exports.default = VERSION;